/*
* @Author: chillylight
* @Date:   2019-10-15 16:16:23
* @Last Modified by:   chillylight
* @Last Modified time: 2019-10-15 16:39:53
*/
import _comMeds from '@src/assets/js/common.js';
import _speInvite from '@src/assets/js/server/speInvite-server.js';
import _vip from '@src/assets/js/server/vip-server.js';
import './index.scss';

var page = {
    data: {

    },
    init: function(){
        this.onLoad();
        this.bindEvent();
    },
    onLoad: function(){
    },
    bindEvent: function(){
        let _this = this;
        // 点击立即报名
        $('body').on('click', '.spe-sign', function(){
            if(!_comMeds.isLogin()){
                _comMeds.doLogin()
            } else{
                _this.getUserLevel();
            }
        })
    },

    experienceApply: function() {
        let subData = {
            activityId: 83
        };
        _speInvite.experienceApply(subData, function(res){
            let str = '<div class="common-shadow-bg">'
                    + '<div class="spe-sign-box">'
                    + '<h3>报名成功！</h3>'
                    + '<p>感谢你来参加翻译狗的生日会，轻寻PDF转换器已备好，欢迎体验。</p>'
                    + '<div class="btn-wrapper">'
                    + '<button class="sm-btn sign-close-btn">我知道啦</button>'
                    +  '<button class="sm-btn sign-know-btn">立即体验</button>'
                    + '</div>'
                    + '</div>'
                    + '</div>'
            $('body').append(str);
            $('body').on('click', '.sign-close-btn', function(){
                $(".common-shadow-bg").remove();
            })
            $('body').on('click', '.sign-know-btn', function(){
                window.location = winPubPath + '/translate/pdfTran.html';
            })
        }, function(res){
            if(res.code == -1300002){
                _comMeds.autoCloseAlert('不在活动期内');
            } else {
                _comMeds.autoCloseAlert(res.msg);
            }
        })
    },
    signFail: function(){
        let str = '<div class="common-shadow-bg">'
                    + '<div class="spe-sign-box">'
                    + '<h3>报名失败！</h3>'
                    + '<p style="padding: 0 100px;">很抱歉，您未能成功开启【特邀体验官】（&gt; ﹏ &lt; 。。）〜</p>'
                    + '<button class="sign-close-btn">我知道了</button>'
                    + '</div>'
                    + '</div>'
            $('body').append(str);
            $('body').on('click', '.sign-close-btn', function(){
                $(".common-shadow-bg").remove();
            })
    },
    getUserLevel: function(){
        let _this = this;
        _vip.getIndexUserInfo({}, function(res) {
           if(res.memberScore.level < 1){
              _this.signFail(); 
           } else {
             _this.experienceApply();
           }
        })
    }
}

$(function(){
    page.init();
})